import { useState, useEffect } from "react";
import { useGetAllUserRoleQuery } from "src/services/UserRoleService";

const useUserRole = () => {
    const [userRole, setUserRole] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllUserRoleQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setUserRole(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { userRole, isDataLoading };
};

export default useUserRole;
